import React, {useEffect, useState} from 'react'
import "./InstitutionComparateurCard.css"
import {GiRotaryPhone} from "react-icons/gi"
import {GoMailRead} from "react-icons/go"
import { useNavigate } from 'react-router-dom'
import { BASE_URL, CDN_BASE_URL } from '../../constants/constants'

const InstitutionComparateurCard = (props) => {
    const {id, libelle, telephone, email, image } = props;
    const navigate = useNavigate()
    useEffect(() => {
       console.log(props)
    }, []);
    return (
        <div onClick={() => navigate(`/institution/${id}`)} className='institution-comparateur-card d-flex flex-nowrap mx-auto '>
<img src={`${CDN_BASE_URL}${image}`} className='institution-comparateur-card-img' />
<div>
    <p className='institution-comparateur-card-libelle'>{libelle}</p>
    <p className='institution-comparateur-card-tel'><GiRotaryPhone style={{width:25, height:25, marginRight: 5, color: "rgba(0, 136, 193, 0.9)"}}/> {telephone}</p>
    <p className='institution-comparateur-card-mail'><GoMailRead style={{width:25, height:25, marginRight: 5, color: "rgba(0, 136, 193, 0.9)"}}/>{email}</p>
</div>
        </div>
    )
}

export default InstitutionComparateurCard